<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPageLoader"
      :color="loaderColor"
      :blur="''"
    ></loading>
    <div>
      <v-wait for="settings">
        <half-circle-spinner
          slot="waiting"
          style="display: block; margin: 0 auto"
          :animation-duration="1000"
          :size="60"
          color="var(--brand-primary)"
        />
        <div class="bg-white rounded mt-3 mb-8">
          <div class="px-4 py-3 border-solid border-grey-200 border-b">
            <h4 class="font-semibold text-grey-700">
              {{ $t('frontend_affiliate_settings_affiliate_settings') }}
            </h4>
            <div class="text-sm text-grey-700">
              {{ $t('frontend_affiliate_settings_you_can_configure') }}
            </div>
          </div>
          <div class="flex">
            <vertical-tabs
                :tabs="affiliateSettingsTabs"
                :currentTab="affiliateSettingsTab"
                :wrapper-class="'pt-5 w-3/12 border-r border-grey-200 pb-10'"
                @onClick="handleAffiiateSettingsTabChange"
              />
            <div class="w-full">
              <div class="py-5 px-6" v-if="affiliateSettingsTab === 'general'">
                <div class="flex flex-col w-1/2 mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2">{{
                    $t('frontend_username')
                  }}</label>
                  <text-input
                    v-model="form.username"
                    :validator="$v.form.username"
                    :attribute="$t('frontend_username')"
                    value="form.username"
                    :placeholder="$t('frontend_affiliate_settings_username')"
                    @input="delayTouch($v.form.username)"
                  />
                </div>
                <div class="flex flex-col w-1/2 mb-6">
                  <label class="font-semibold text-sm text-grey-700 mb-2"
                    >{{ $t('frontend_affiliate') }} Id</label
                  >
                  <text-input
                    v-model="userId"
                    :attribute="$t('frontend_groovesell_affiliate_id')"
                    value="userId"
                    placeholder=""
                    :readonly="true"
                    :disabled="true"
                  />
                </div>
              </div>
              <div v-else-if="affiliateSettingsTab === 'payment'">
                <div class="flex">
                    <vertical-tabs
                      :tabs="affiliatePaymentSettingsTabs"
                      :currentTab="affiliatePaymentSettingsTab"
                      :wrapper-class="'pt-5 w-3/12 border-r border-grey-200 pb-10'"
                      @onClick="handleAffiiatePaymentSettingsTabChange"
                    />
                  <div class="w-full py-5 px-6">
                    <div v-if="affiliatePaymentSettingsTab === 'paypal'">
                      <div class="flex flex-col w-1/2 mb-6">
                        <label class="font-semibold text-sm text-grey-700 mb-2">{{
                          $t('frontend_affiliate_settings_paypal_email_id')
                        }}</label>
                        <text-input
                          v-model="form.affiliate_paypal_email"
                          value="form.affiliate_paypal_email"
                          placeholder="email@paypal.com"
                        />
                      </div>
                    </div>
                    <div v-else-if="affiliatePaymentSettingsTab === 'wire'">
                      <div class="flex flex-col w-full mb-6">
                        <label class="font-semibold text-sm text-grey-700 mb-2">{{
                          $t('frontend_affiliate_settings_account_name')
                        }}</label>
                        <text-input
                          v-model="form.affiliate_wire_info.account_name"
                          value="form.affiliate_wire_info.account_name"
                          :placeholder="
                            $t('frontend_affiliate_settings_account_name')
                          "
                        />
                      </div>
                      <div class="flex flex-col w-full mb-6">
                        <label class="font-semibold text-sm text-grey-700 mb-2">{{
                          $t('frontend_affiliate_settings_address')
                        }}</label>
                        <text-input
                          v-model="form.affiliate_wire_info.address"
                          :value="form.affiliate_wire_info.address"
                          :placeholder="$t('frontend_affiliate_settings_address')"
                        />
                      </div>
                      <div class="flex flex-row w-full mb-6">
                        <div class="flex flex-col mr-2 w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_city')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.city"
                            value="form.affiliate_wire_info.city"
                            :placeholder="$t('frontend_affiliate_settings_city')"
                          />
                        </div>
                        <div class="flex flex-col w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_state')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.state"
                            value="form.affiliate_wire_info.state"
                            :placeholder="$t('frontend_affiliate_settings_state')"
                          />
                        </div>
                      </div>

                      <div class="flex flex-row w-full mb-6">
                        <div class="flex flex-col mr-2 w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_bank_name')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.main_bank_name"
                            value="form.affiliate_wire_info.main_bank_name"
                            :placeholder="
                              $t('frontend_affiliate_settings_bank_name')
                            "
                          />
                        </div>
                        <div class="flex flex-col w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_account_number')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.main_bank_account_no"
                            value="form.affiliate_wire_info.main_bank_account_no"
                            :placeholder="
                              $t('frontend_affiliate_settings_account_number')
                            "
                          />
                        </div>
                      </div>
                      <div class="flex flex-row w-full mb-6">
                        <div class="flex flex-col mr-2 w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_postal_code')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.postal_code"
                            value="form.affiliate_wire_info.postal_code"
                            :placeholder="
                              $t('frontend_affiliate_settings_postal_code')
                            "
                          />
                        </div>
                        <div class="flex flex-col w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_country')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.country"
                            value="form.affiliate_wire_info.country"
                            :placeholder="$t('frontend_affiliate_settings_country')"
                          />
                        </div>
                      </div>
                      <div class="flex flex-col w-full mb-6">
                        <label class="font-semibold text-sm text-grey-700 mb-2">{{
                          $t('frontend_affiliate_settings_bank_address')
                        }}</label>
                        <text-input
                          v-model="form.affiliate_wire_info.main_bank_address"
                          value="form.affiliate_wire_info.main_bank_address"
                          :placeholder="
                            $t('frontend_affiliate_settings_bank_address')
                          "
                        />
                      </div>
                      <div class="flex flex-row w-full mb-6">
                        <div class="flex flex-col mr-2 w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_routing_number')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.main_bank_routing_no"
                            value="form.affiliate_wire_info.main_bank_routing_no"
                            :placeholder="
                              $t('frontend_affiliate_settings_routing_number')
                            "
                          />
                        </div>
                        <div class="flex flex-col w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_swift')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.main_bank_swift_code"
                            value="form.affiliate_wire_info.main_bank_swift_code"
                            :placeholder="$t('frontend_affiliate_settings_swift')"
                          />
                        </div>
                      </div>
                      <div class="flex flex-row w-full mb-6">
                        <div class="flex flex-col mr-2 w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_aba')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.main_bank_aba"
                            value="form.affiliate_wire_info.main_bank_aba"
                            :placeholder="$t('frontend_affiliate_settings_aba')"
                          />
                        </div>
                        <div class="flex flex-col w-1/2">
                          <label class="font-semibold text-sm text-grey-700 mb-2">{{
                            $t('frontend_affiliate_settings_iban')
                          }}</label>
                          <text-input
                            v-model="form.affiliate_wire_info.main_bank_iban"
                            value="form.affiliate_wire_info.main_bank_iban"
                            :placeholder="$t('frontend_affiliate_settings_iban')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="py-5 px-6" v-else-if="affiliateSettingsTab === 'tax'">
                <div class="flex flex-col w-full p-2">
                  <div class="flex flex-col">
                    <label class="font-semibold text-sm text-grey-700 mb-2"
                      >{{ $t('frontend_legal_name') }}</label
                    >
                    <text-input
                      v-model="form.affiliate_legal_name"
                      value="form.affiliate_legal_name"
                      :placeholder="$t('frontend_legal_name')"
                    />
                  </div>
                  <div class="flex flex-row mt-4 w-full">
                    <div class="flex flex-col mr-2 w-1/2">
                      <label class="font-semibold text-sm text-grey-700 mb-2"
                        >{{ $t('frontend_address') }}</label
                      >
                      <text-input
                        v-model="form.affiliate_legal_address"
                        value="form.affiliate_legal_address"
                        :placeholder="$t('frontend_address')"
                      />
                    </div>
                    <div class="flex flex-col w-1/2">
                      <label class="font-semibold text-sm text-grey-700 mb-2"
                        >{{ $t('frontend_address') }} 2</label
                      >
                      <text-input
                        v-model="form.affiliate_legal_address_2"
                        value="form.affiliate_legal_address_2"
                        :placeholder="$t('frontend_address')"
                      />
                    </div>
                  </div>
                  <div class="flex flex-row mt-4 w-full">
                    <div class="flex flex-col mr-2 w-1/2">
                      <label class="font-semibold text-sm text-grey-700 mb-2"
                        >{{ $t('frontend_city') }}</label
                      >
                      <text-input
                        v-model="form.affiliate_legal_city"
                        value="form.affiliate_legal_city"
                        :placeholder="$t('frontend_city')"
                      />
                    </div>
                    <div class="flex flex-col w-1/2">
                      <label class="font-semibold text-sm text-grey-700 mb-2"
                        >{{ $t('frontend_state') }}</label
                      >
                      <text-input
                        v-model="form.affiliate_legal_state"
                        value="form.affiliate_legal_state"
                        :placeholder="$t('frontend_state')"
                      />
                    </div>
                  </div>
                  <div class="flex flex-row mt-4 w-full">
                    <div class="flex flex-col mr-2 w-1/2">
                      <label class="font-semibold text-sm text-grey-700 mb-2"
                        >{{ $t('frontend_postal_code') }}</label
                      >
                      <text-input
                        v-model="form.affiliate_legal_zip_code"
                        value="form.affiliate_legal_zip_code"
                        :placeholder="$t('frontend_postal_code')"
                      />
                    </div>
                    <div class="flex flex-col w-1/2">
                      <label class="font-semibold text-sm text-grey-700 mb-2"
                        >{{ $t('frontend_country') }}</label
                      >
                      <text-input
                        v-model="form.affiliate_legal_country"
                        value="form.affiliate_legal_country"
                        :placeholder="$t('frontend_country')"
                      />
                    </div>
                  </div>
                  <div class="flex flex-col mt-4">
                    <label class="font-semibold text-sm text-grey-700 mb-2"
                      >{{ $t('frontend_affiliate_settings_tax_id') }}</label
                    >
                    <text-input
                      v-model="form.affiliate_tax_id"
                      value="form.affiliate_tax_id"
                      :placeholder="$t('frontend_affiliate_settings_tax_id')"
                    />
                  </div>
                  <div class="flex flex-col mt-4">
                    <div class="flex">
                      <label class="font-semibold text-grey-700 mb-2">
                        {{ $t('frontend_affiliate_settings_citizenship_status') }}
                      </label>
                    </div>
                    <fieldset class="mb-4">
                      <legend class="sr-only">{{ $t('frontend_affiliate_settings_citizenship_status') }}</legend>
                      <div class="flex flex-row w-full">
                        <label
                          class="
                            border
                            rounded
                            py-3
                            px-3
                            flex
                            items-center
                            justify-center
                            text-sm
                            uppercase
                            sm:flex-1
                            cursor-pointer
                            focus:outline-none
                            border-grey-300
                            mr-4
                            font-semibold
                            text-center
                          "
                          :class="{
                            'bg-primary border-transparent text-white hover:bg-primary-dark':
                              form.affiliate_tax_resident_type ==
                              citizenshipType.id,
                            'bg-white border-grey-200 text-grey-900 hover:bg-grey-50':
                              form.affiliate_tax_resident_type !=
                              citizenshipType.id,
                          }"
                          v-for="(citizenshipType, index) in citizenshipTypes"
                          :key="index"
                        >
                          <input
                            type="radio"
                            name="citizenship-type"
                            :value="citizenshipType.id"
                            class="sr-only"
                            v-model="form.affiliate_tax_resident_type"
                          />
                          <p>{{ citizenshipType.title }}</p>
                        </label>
                      </div>
                    </fieldset>
                  </div>
                  <div class="mt-4" v-if="form.affiliate_tax_resident_type > 0">
                    <div
                      class="
                        flex flex-row
                        justify-between
                        border border-grey-300
                        rounded
                        p-4
                      "
                      v-if="form.affiliate_tax_form"
                    >
                      <div
                        class="
                          flex flex-col
                          text-green-dark
                          font-semibold
                          text-lg
                          w-1/2
                        "
                      >
                        <span>
                          {{
                            form.affiliate_tax_resident_type == 1 ||
                            form.affiliate_tax_resident_type == 2
                              ? 'W-9'
                              : 'W-8BEN'
                          }}
                          Form Filled In
                          <i class="ml-1 fas fa-check-circle"></i>
                        </span>
                      </div>
                      <div class="w-1/2 flex flex-row justify-end">
                        <gd-button
                          size="auto"
                          variant="primary"
                          class="p-4 mr-2"
                          @click="previewTaxForm"
                          >Preview File</gd-button
                        >
                        <gd-button
                          size="auto"
                          variant="primary"
                          class="p-4 mr-2"
                          @click="downloadTaxForm"
                          >{{ $t('frontend_download_file') }}</gd-button
                        >
                        <gd-button
                          size="auto"
                          variant="primary"
                          class="p-4"
                          @click="removeTaxForm"
                          >{{ $t('frontend_remove_file') }}</gd-button
                        >
                      </div>
                    </div>
                    <div class="flex flex-col" v-else>
                      <div class="text-dark flex flex-row">
                        <div>
                          <span class="font-bold">Step 1: </span>
                          Please download the
                          {{
                            form.affiliate_tax_resident_type == 1 ||
                            form.affiliate_tax_resident_type == 2
                              ? 'W-9'
                              : 'W-8BEN'
                          }}
                          form by
                          <template
                            v-if="
                              form.affiliate_tax_resident_type == 1 ||
                              form.affiliate_tax_resident_type == 2
                            "
                            >clicking on the "Download W-9 Form" button</template
                          >
                          <template
                            v-if="
                              form.affiliate_tax_resident_type == 3 ||
                              form.affiliate_tax_resident_type == 4
                            "
                            >clicking on the "Download W-8BEN Form"
                            button</template
                          >
                          <span class="font-bold"> -> </span>
                        </div>
                        <div class="-mt-1">
                          <gd-button
                            v-if="
                              form.affiliate_tax_resident_type == 1 ||
                              form.affiliate_tax_resident_type == 2
                            "
                            size="auto"
                            variant="primary"
                            class="p-4 ml-2"
                            @click="
                              getAdminFileURL('Groove-Affiliate-W-9-form.pdf')
                            "
                            >Download W-9 Form</gd-button
                          >
                          <simple-dropdown
                            v-else-if="
                              form.affiliate_tax_resident_type == 3 ||
                              form.affiliate_tax_resident_type == 4
                            "
                            title="Download W-8BEN Form"
                            :options="w8Types"
                            @selected="downloadW8Form($event)"
                            class="ml-2"
                          ></simple-dropdown>
                        </div>
                      </div>
                      <div class="text-dark mt-4">
                        <span class="font-bold">Step 2: </span>
                        Fill the required details with all the info and save it.
                      </div>
                      <div class="flex flex-col w-full mt-4">
                        <div class="text-dark mb-4">
                          <span class="font-bold">Step 3: </span>
                          Upload the completed PDF file and click "Save"
                        </div>
                        <vue-dropzone
                          id="customdropzone"
                          ref="myVueDropzone"
                          :options="dropzoneOptions"
                          :use-custom-slot="true"
                          @vdropzone-file-added="fileAdded"
                          @vdropzone-error="() => {}"
                          @vdropzone-upload-progress="() => {}"
                          @vdropzone-total-upload-progress="() => {}"
                          @vdropzone-success="() => {}"
                        >
                          <div class="dropzone-custom-content">
                            <div
                              class="
                                rounded-lg
                                bgcolor
                                flex flex-col
                                h-40
                                justify-center
                                items-center
                                px-4
                              "
                            >
                              <div
                                class="
                                  w-full
                                  flex flex-row flex-nowrap
                                  items-center
                                  justify-center
                                  text-sm
                                  subtitle
                                  mb-1
                                "
                              >
                                {{
                                  $t('frontend_groovemember_files_drag_and_drop')
                                }}
                              </div>
                              <div
                                class="
                                  w-full
                                  flex flex-row flex-nowrap
                                  items-center
                                  justify-center
                                  text-sm
                                  subtitle
                                  mb-3
                                "
                              >
                                - {{ $t('frontend_groovemember_files_or') }} -
                              </div>
                              <div
                                class="
                                  w-full
                                  flex flex-row flex-nowrap
                                  items-center
                                  justify-center
                                "
                              >
                                <gd-button variant="primary" class="px-4 w-auto mr-2">
                                  {{ $t('frontend_groovemember_select_file') }}
                                </gd-button>
                              </div>
                              <div
                                class="
                                  text-sm
                                  subtitle
                                  mt-3
                                  w-full
                                  flex flex-row flex-nowrap
                                  items-center
                                  justify-center
                                "
                              >
                                Max Size : 2MB
                              </div>
                            </div>
                          </div>
                        </vue-dropzone>
                        <div class="flex justify-center mt-2">
                          <gd-button
                            v-if="this.upload_file.file"
                            size="auto"
                            variant="primary"
                            class="
                              h-10
                              modal-btn-width
                              px-4
                              btn-radius
                              text-base
                              font-semibold
                            "
                            @click="uploadFilesToServer"
                          >
                            {{ $t('frontend_groovemember_files_upload_file') }}
                          </gd-button>
                          <gd-button
                            v-else
                            disabled
                            size="auto"
                            variant="primary"
                            class="
                              h-10
                              modal-btn-width
                              px-4
                              btn-radius
                              text-base
                              font-semibold
                            "
                          >
                            {{ $t('frontend_groovemember_files_upload_file') }}
                          </gd-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="border-grey-100 -mx-4" />
              <div
                v-if="affiliateSettingsTab == 'general'"
                class="flex flex-row-reverse pr-2 pb-4"
              >
                <gd-button
                  v-if="!$v.form.username.$invalid"
                  primary
                  size="large"
                  class="text-center mt-6"
                  @click="saveAffiliateSettings"
                  >{{ $t('frontend_save') }}</gd-button
                >
                <gd-button
                  v-else
                  disabled
                  size="large"
                  class="text-center mt-6 cursor-not-allowed"
                  >{{ $t('frontend_save') }}</gd-button
                >
              </div>
              <div
                v-if="affiliateSettingsTab == 'tax'"
                class="flex flex-row-reverse pr-2 pb-4"
              >
                <gd-button
                  v-if="
                    !$v.form.affiliate_legal_name.$invalid &&
                    !$v.form.affiliate_legal_address.$invalid &&
                    !$v.form.affiliate_legal_city.$invalid &&
                    !$v.form.affiliate_legal_state.$invalid &&
                    !$v.form.affiliate_legal_country.$invalid &&
                    !$v.form.affiliate_legal_zip_code.$invalid &&
                    !$v.form.affiliate_tax_resident_type.$invalid &&
                    !$v.form.affiliate_tax_id.$invalid &&
                    !$v.form.affiliate_tax_form.$invalid
                  "
                  variant="primary"
                  size="large"
                  class="text-center mt-6"
                  @click="saveAffiliateSettings"
                  >{{ $t('frontend_save') }}</gd-button
                >
                <gd-button
                  v-else
                  disabled
                  size="lg"
                  class="text-center mt-6 cursor-not-allowed"
                  >{{ $t('frontend_save') }}</gd-button
                >
              </div>
              <div
                v-if="affiliateSettingsTab == 'payment'"
                class="flex flex-row-reverse pr-2 pb-4"
              >
                <gd-button
                  variant="primary"
                  size="lg"
                  class="text-center mt-6"
                  @click="saveAffiliateSettings"
                  >{{ $t('frontend_save') }}</gd-button
                >
              </div>
            </div>
          </div>
        </div>
      </v-wait>
    </div>
  </div>
</template>

<script>
import Notify from '../../../notify';
import axios from 'axios';
import Swal from 'sweetalert2';
import Form from 'vform';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
maxLength,
minLength,
required
} from 'vuelidate/lib/validators';
import VerticalTabs from '../VerticalTabs';
import SimpleDropdown from './components/SimpleDropdown';
import createLinkMixin from './mixins/createLinkMixin';

const touchMap = new WeakMap();
export default {
  middleware: 'auth',
  layout: 'defaultForAffiliates',
  mixins: [createLinkMixin],
  components: {
    Loading,
    SimpleDropdown,
    vueDropzone: vue2Dropzone,
    VerticalTabs,
  },
  data() {
    return {
      form: new Form({
        username: '',
        affiliate_paypal_email: '',
        affiliate_tax_id: '',
        affiliate_legal_name: '',
        affiliate_legal_address: '',
        affiliate_legal_address_2: '',
        affiliate_legal_city: '',
        affiliate_legal_state: '',
        affiliate_legal_country: '',
        affiliate_legal_zip_code: '',
        affiliate_tax_resident_type: 0,
        affiliate_tax_form: '',
      }),
      w8Types: [
        {
          id: 'Groove-Affiliate-W-8-BEN-form.pdf',
          name: 'Download W-8BEN For An Individual',
          disabled: false,
        },
        {
          id: 'Groove-Affiliate-W-8-BENE-form.pdf',
          name: 'Download W-8BEN-E For An Entity',
          disabled: false,
        },
      ],
      addedW8Form: '',
      addedW9Form: '',
      currentUploadedFile: null,
      dropzoneOptions: {
        url: `${window.config.apiUrl.split('/api')[0]}/api/groovesell/upload`,
        timeout: 99999999,
        maxFiles: 1,
        maxFilesize: 2,
        autoProcessQueue: false,
        autoQueue: true,
        method: 'put',
        acceptedFiles: '.pdf',
      },
      upload_file: {
        name: '',
        file: null,
      },
      userId: 0,
      isLoading: false,
      fullPageLoader: true,
      loaderColor: 'var(--brand-primary)',
      affiliateSettingsTabs: [
        {
          title: this.$t('frontend_affiliate_settings_general'),
          value: 'general',
        },
        {
          title: this.$t('frontend_affiliate_settings_payment'),
          value: 'payment',
        },
        {
          title: this.$t('frontend_affiliate_settings_tax_info'),
          value: 'tax',
        },
      ],
      citizenshipTypes: [
        {
          id: 1,
          title: this.$t('frontend_affiliate_us_citizen_in_us'),
          description: '',
        },
        {
          id: 2,
          title: this.$t('frontend_affiliate_us_citizen_in_non_us'),
          description: '',
        },
        {
          id: 3,
          title: this.$t('frontend_affiliate_non_us_citizen_in_us'),
          description: '',
        },
        {
          id: 4,
          title: this.$t('frontend_affiliate_non_us_citizen_in_non_us'),
          description: '',
        },
      ],
      affiliateSettingsTab: 'general',
      affiliatePaymentSettingsTabs: [
        {
          title: this.$t('frontend_affiliate_settings_paypal'),
          value: 'paypal',
        },
        { title: this.$t('frontend_affiliate_settings_wire'), value: 'wire' },
      ],
      affiliatePaymentSettingsTab: 'paypal',
      genericUrl: `${window.config.apiUrl.split('/api')[0]}/api`,
    };
  },
  watch: {
    'form.affiliate_tax_resident_type': function (newVal, oldVal) {
      if (oldVal > 0 && newVal > 0) {
        if (newVal == 1 || newVal == 2) {
          if (this.addedW9Form != '') {
            this.form.affiliate_tax_form = this.addedW9Form;
          } else {
            this.form.affiliate_tax_form = '';
          }
        } else if (newVal == 3 || newVal == 4) {
          if (this.addedW8Form != '') {
            this.form.affiliate_tax_form = this.addedW8Form;
          } else {
            this.form.affiliate_tax_form = '';
          }
        }
      }
    },

    'form.affiliate_tax_form': function (newVal, oldVal) {
      if (newVal != '' && this.form.affiliate_tax_resident_type > 0) {
        if (
          this.form.affiliate_tax_resident_type == 1 ||
          this.form.affiliate_tax_resident_type == 2
        ) {
          this.addedW9Form = newVal;
        } else {
          this.addedW8Form = newVal;
        }
      }
    },
  },
  metaInfo() {
    return { title: 'Affiliate Settings' };
  },
  validations: {
    form: {
      username: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(255),
        async isUnique(value) {
          if (value === '') {
            return true;
          }

          let userNameFlag = false;
          await axios
            .get(`${this.genericUrl}/groovesell/validate-username/${value}`)
            .then(() => {
              userNameFlag = true;
            })
            .catch(() => {
              userNameFlag = false;
            });

          return userNameFlag;
        },
      },
      affiliate_legal_name: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(1000),
      },
      affiliate_legal_address: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(1000),
      },
      affiliate_legal_city: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_legal_state: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_legal_country: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_legal_zip_code: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_tax_id: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(1000),
      },
      affiliate_tax_resident_type: {
        required,
      },
      affiliate_tax_form: {
        required,
      },
    },
  },
  async created() {
    this.$wait.start('settings');
    const mainAppUrl = `${window.config.apiUrl.split('/api')[0]}/api`;
    const { data } = await axios.get(`${mainAppUrl}/groovesell/affiliate-settings`);
    this.userId = data.affiliate_id;
    this.form.username = data.username;
    this.form.affiliate_paypal_email = data.affiliate_paypal_email;
    this.form.affiliate_wire_info = data.affiliate_wire_info;
    this.form.affiliate_tax_id = data.affiliate_tax_id;
    this.form.affiliate_legal_name = data.affiliate_legal_name;
    this.form.affiliate_legal_address = data.affiliate_legal_address;
    this.form.affiliate_legal_address_2 = data.affiliate_legal_address_2;
    this.form.affiliate_legal_city = data.affiliate_legal_city;
    this.form.affiliate_legal_state = data.affiliate_legal_state;
    this.form.affiliate_legal_country = data.affiliate_legal_country;
    this.form.affiliate_legal_zip_code = data.affiliate_legal_zip_code;
    this.form.affiliate_tax_resident_type = data.affiliate_tax_resident_type;
    this.form.affiliate_tax_form = data.affiliate_tax_form;
    // await this.$v.$touch();
    this.$wait.end('settings');
  },
  async mounted() {},
  methods: {
    downloadW8Form(id) {
      this.getAdminFileURL(id);
    },

    previewTaxForm() {
      this.openLink(
        `${this.genericUrl}/groovesell/download-user-files/${this.form.affiliate_tax_form}`,
        '_blank'
      );
    },

    downloadTaxForm() {
      this.openLink(
        `${this.genericUrl}/groovesell/download-user-files/${this.form.affiliate_tax_form}?is_download=1`,
        '_blank'
      );
    },

    async removeTaxForm() {
      const { value: accept } = await Swal.fire({
        title: this.$t('frontend_sure'),
        text: this.$t('frontend_swal_remove_tax_form_text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('frontend_swal_remove_tax_form_btn_confirm'),
      });
      if (accept) {
        this.form.affiliate_tax_form = '';
      }
    },

    async uploadFilesToServer() {
      if (this.upload_file) {
        const self = this;
        this.showLoader();
        axios
          .post(`${this.genericUrl}/groovesell/get-pre-sign-url`, {
            fileName: this.upload_file.file.name,
          })
          .then(async (res) => {
            this.uploadedFileName = res.data.file;
            // this.affiliate_tax_form = res.data.file;
            const uninterceptedAxiosInstance = axios.create();
            uninterceptedAxiosInstance
              .put(res.data.postEndpoint, this.upload_file.file, {
                onUploadProgress: (p) => {
                  this.uploadProgressStatus = Math.round(
                    (p.loaded / p.total) * 100
                  );

                  if (this.upload_file.file.previewElement) {
                    const progressElement =
                      this.upload_file.file.previewElement.querySelector(
                        '[data-dz-uploadprogress]'
                      );
                    progressElement.style.width = `${this.uploadProgressStatus}%`;
                    progressElement.textContent = `${this.uploadProgressStatus}%`;
                  }
                },
              })
              .then(async (uploadRes) => {
                console.log(uploadRes);
                this.form.affiliate_tax_form = this.uploadedFileName;
                this.hideLoader();
                /*
                this.fileUploaded({
                  name: this.upload_file.file.name,
                  size: this.upload_file.file.size,
                  type: this.upload_file.file.type,
                });
                */
              })
              .catch((e) => {
                this.hideLoader();
                this.onUploaderError(
                  this.upload_file.file,
                  'Error occurred while uploading file'
                );
              });
          });
      }
    },

    async fileUploaded(response) {
      console.log('in fileuploaded');
      console.log(response);
    },

    fileAdded(addedFile) {
      if (this.currentUploadedFile) {
        this.$refs.myVueDropzone.removeFile(this.currentUploadedFile);
      }
      this.currentUploadedFile = addedFile;
      this.upload_file.file = addedFile;
    },

    async getAdminFileURL(fileName) {
      const url = `${this.genericUrl}/groovesell/download-admin-files/${fileName}`;
      this.openLink(url, '_blank');
    },

    async downloadItem({ url, label }) {
      const response = await axios.get(url, { responseType: 'blob' });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
    },

    handleAffiiateSettingsTabChange(newTab) {
      this.affiliateSettingsTab = newTab;
    },

    handleAffiiatePaymentSettingsTabChange(newTab) {
      this.affiliatePaymentSettingsTab = newTab;
    },

    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1000));
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    async saveAffiliateSettings() {
      // this.$v.$touch();
      let isFormValid = true;
      if (this.affiliateSettingsTab == 'general') {
        this.$v.$touch();
        isFormValid = !this.$v.form.username.$$invalid;
      } else if (this.affiliateSettingsTab == 'tax') {
        this.$v.$touch();
        isFormValid =
          !this.$v.form.affiliate_legal_name.$invalid &&
          !this.$v.form.affiliate_legal_address.$invalid &&
          !this.$v.form.affiliate_legal_city.$invalid &&
          !this.$v.form.affiliate_legal_state.$invalid &&
          !this.$v.form.affiliate_legal_country.$invalid &&
          !this.$v.form.affiliate_legal_zip_code.$invalid &&
          !this.$v.form.affiliate_tax_resident_type.$invalid &&
          !this.$v.form.affiliate_tax_id.$invalid &&
          !this.$v.form.affiliate_tax_form.$invalid;
      }
      if (isFormValid) {
        const self = this;

        self.showLoader();

        await self.form
          .post(`${this.genericUrl}/groovesell/save-affiliate-settings`)
          .then(() => {
            self.hideLoader();
            Notify.success('Successfully saved your affiliate settings');
          })
          .catch(() => {
            self.hideLoader();
            Notify.fail(
              'Unable to save your affiliate settings. Please refresh this page and try again'
            );
          });
      }
    },
  },
};
</script>

<style>
.dropzone .dz-preview .dz-progress {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  height: 20px !important;
}
</style>
<style scoped>
#customdropzone {
  width: 100%;
}
</style>